import axios from "axios";

import { api } from "../../apis";
import { helperFunction } from "../../constant/helper";
import { types } from "../type";

// set loading
const setUserLoading = (data) => (dispatch) => {
  dispatch({
    type: types.UserTypes.USER_SET_LOADING,
    payload: data
  });
};

// set loading
const setAddDeviceLoading = (data) => (dispatch) => {
  dispatch({
    type: types.UserTypes.ADD_DEVICE_SET_LOADING,
    payload: data
  });
};

// clear result
const clearUserResult = () => (dispatch) => {
  dispatch({
    type: types.UserTypes.USER_CLEAR_RESULT
  });
};

// unmount
const unmountAllUsersData = () => (dispatch) => {
  dispatch({
    type: types.UserTypes.USER_UNMOUNT
  });
};

// clear error
const clearUserErrors = () => (dispatch) => {
  dispatch({
    type: types.UserTypes.USER_CLEAR_ERRORS
  });
};

// set loading
const setAddLocationLoading = (data) => (dispatch) => {
  dispatch({
    type: types.UserTypes.ADD_LOCATION_TO_USER_LOADING,
    payload: data
  });
};

const addLocationToUserAction = (
  addLocationData,
  loginType
) => async (dispatch) => {
  try {
    const { baseUrlPython } = await helperFunction.checkLoginType(
      loginType
    );
    const addPhotoSuccess = await axios.post(
      `${baseUrlPython}${api.Users_Api.ADD_LOCATION_TO_USER_API}`,
      addLocationData
    );
    dispatch({
      type: types.UserTypes.ADD_LOCATION_TO_USER,
      payload: addPhotoSuccess.data
    });
  } catch (addPhotoError) {
    const errorData = {
      data: addPhotoError.response.data,
      status: addPhotoError.response.status
    };
    dispatch({
      type: types.UserTypes.USER_GET_ERRORS,
      payload: errorData
    });
  }
};

const getFunction = async (
  url,
  type,
  errorType,
  dispatch,
  payloadData = [],
  dataType = ""
) => {
  try {
    const getRequestSuccess = await axios.get(url);

    const { data } = getRequestSuccess;
    dispatch({
      type: type,
      payload: { data, payloadData, dataType }
    });
  } catch (getRequestError) {
    console.log(getRequestError);
    const errorData = {
      data: getRequestError.response.data,
      status: getRequestError.response.status
    };

    dispatch({
      type: errorType,
      payload: errorData
    });
  }
};

const getAllUserImages = (
  isDynamic,
  values,
  loginType,
  page,
  limit
) => async (dispatch) => {
  const { baseUrlNode } = await helperFunction.checkLoginType(
    loginType
  );
  const url = `${baseUrlNode}${api.Users_Api.GET_ALL_USERS_IMAGES_API}/${isDynamic}/${values.workerId}/${values.locationId}/${loginType}?page=${page}&limit=${limit}`;
  const type = types.UserTypes.GET_ALL_USERS_IMAGES;
  const errorType = types.UserTypes.USER_GET_ERRORS;

  getFunction(url, type, errorType, dispatch);
};

// get all user by location id and login type
const getAllUsers = (
  dataType,
  loginType,
  locationId,
  status,
  userDepartment,
  filter,
  workerId,
  isDynamic,
  page,
  limit,
  dataToGetAllUser,
  selectedValues
) => async (dispatch) => {
  const { baseUrlNode } = await helperFunction.checkLoginType(
    loginType
  );
  const url = `${baseUrlNode}${api.Users_Api.GET_ALL_USERS_API}/${loginType}/${locationId}/${userDepartment}/${status}/${dataToGetAllUser}?page=${page}&limit=${limit}`;
  const type = types.UserTypes.GET_USERS;
  const errorType = types.UserTypes.USER_GET_ERRORS;
  // console.log(url);
  dispatch({
    type: types.UserTypes.ALL_USER_INPUTS,
    payload: {
      locationId,
      status,
      userDepartment,
      filter,
      workerId,
      isDynamic,
      selectedValues,
      dataType
    }
  });
  getFunction(url, type, errorType, dispatch, selectedValues);
};

// get all user by location id and login type anf filter
const getAllFilterUsers = (
  locationId,
  workerId,
  loginType,
  isDynamic,
  dataToGetAllUser,
  selectedValues
) => async (dispatch) => {
  const { baseUrlNode } = await helperFunction.checkLoginType(
    loginType
  );
  const url = `${baseUrlNode}${api.Users_Api.GET_ALL_USERS_FILTER_API}/${loginType}/${locationId}/${workerId}/${dataToGetAllUser}`;
  const type = types.UserTypes.GET_USERS;
  const errorType = types.UserTypes.USER_GET_ERRORS;
  dispatch({
    type: types.UserTypes.ALL_USER_INPUTS_DYNAMIC,
    payload: { locationId, workerId, isDynamic, selectedValues }
  });
  getFunction(url, type, errorType, dispatch, selectedValues);
};

// get user detail
const getUserDetail = (userId, loginType, filterBy) => async (
  dispatch
) => {
  const { baseUrlNode } = await helperFunction.checkLoginType(
    loginType
  );
  const url = `${baseUrlNode}${api.Users_Api.GET_USER_DETAIL_API}/${userId}/${loginType}/${filterBy}`;
  const type = types.UserTypes.GET_USER_DETAIL;
  const errorType = types.UserTypes.USER_GET_ERRORS;
  getFunction(url, type, errorType, dispatch);
};

// get user detail
const getUserCalendarData = (userId, dateRange, loginType) => async (
  dispatch
) => {
  const { baseUrlNode } = await helperFunction.checkLoginType(
    loginType
  );
  const url = `${baseUrlNode}${api.Attendance_Api.GET_ATTENDANCE_SHEET_API}/${dateRange.fromDate}/${dateRange.toDate}/${userId}/${loginType}/user`;
  const type = types.UserTypes.GET_USER_CALENDAR_DATA;
  const errorType = types.UserTypes.USER_GET_ERRORS;
  dispatch({
    type: types.UserTypes.USER_WISE_ATTEND_INPUT,
    payload: { dateRange, userId }
  });
  getFunction(url, type, errorType, dispatch);
};

// get all user by location id and logint type
// const getAllAwsUsers = (loginType) => async (dispatch) => {
//   const { baseUrlPython } = await helperFunction.checkLoginType(
//     loginType
//   );
//   const url = `${baseUrlPython}${api.Users_Api.GET_ALL_AWS_USERS_API}/${loginType}`;
//   const type = types.UserTypes.GET_AWS_USERS;
//   const errorType = types.UserTypes.USER_GET_ERRORS;
//   getFunction(url, type, errorType, dispatch);
// };

// get all devices
const getDevices = (locationId, loginType) => async (dispatch) => {
  const { baseUrlNode } = await helperFunction.checkLoginType(
    loginType
  );
  const url = `${baseUrlNode}${api.Users_Api.GET_DEVICE_API}/${locationId}`;
  const type = types.UserTypes.GET_DEVICE;
  const errorType = types.UserTypes.USER_GET_ERRORS;
  getFunction(url, type, errorType, dispatch);
};

// delete photo
const deleteDevices = (deviceData, loginType) => async (dispatch) => {
  try {
    const { baseUrlNode } = await helperFunction.checkLoginType(
      loginType
    );
    const deleteDeviceSuccess = await axios.post(
      `${baseUrlNode}${api.Users_Api.DELETE_DEVICE_API}`,
      deviceData
    );
    dispatch({
      type: types.UserTypes.ADD_DEVICE,
      payload: deleteDeviceSuccess.data
    });
  } catch (deleteDeviceError) {
    const errorData = {
      data: deleteDeviceError.response.data,
      status: deleteDeviceError.response.status
    };
    dispatch({
      type: types.UserTypes.USER_GET_ERRORS,
      payload: errorData
    });
  }
};

// add photo
const addDevices = (deviceData, loginType) => async (dispatch) => {
  try {
    const { baseUrlNode } = await helperFunction.checkLoginType(
      loginType
    );
    const deviceId = "addDevice";
    const addDeviceSuccess = await axios.post(
      `${baseUrlNode}${api.Users_Api.ADD_DEVICE_API}/${deviceId}`,
      deviceData
    );
    dispatch({
      type: types.UserTypes.ADD_DEVICE,
      payload: addDeviceSuccess.data
    });
  } catch (addDeviceError) {
    const errorData = {
      data: addDeviceError.response.data,
      status: addDeviceError.response.status
    };
    dispatch({
      type: types.UserTypes.USER_GET_ERRORS,
      payload: errorData
    });
  }
};

// add photo
const addPhoto = (userImageInfo, loginType) => async (dispatch) => {
  try {
    const { baseUrlPython } = await helperFunction.checkLoginType(
      loginType
    );
    const addPhotoSuccess = await axios.post(
      `${baseUrlPython}${api.Users_Api.USER_PHOTO_REGISTER_API}`,
      userImageInfo
    );
    dispatch({
      type: types.UserTypes.ADD_PHOTO,
      payload: addPhotoSuccess.data
    });
  } catch (addPhotoError) {
    const errorData = {
      data: addPhotoError.response.data,
      status: addPhotoError.response.status
    };
    dispatch({
      type: types.UserTypes.USER_GET_ERRORS,
      payload: errorData
    });
  }
};

// on reset password
const resetPassword = (userId, loginType) => async (dispatch) => {
  try {
    const { baseUrlNode } = await helperFunction.checkLoginType(
      loginType
    );
    const resetPasswordSuccess = await axios.post(
      `${baseUrlNode}${api.Users_Api.USER_RESET_PASSWORD_API}/${userId}`
    );
    dispatch({
      type: types.UserTypes.USER_RESET_PASSWORD,
      payload: resetPasswordSuccess.data
    });
  } catch (resetPasswordError) {
    const errorData = {
      data: resetPasswordError.response.data,
      status: resetPasswordError.response.status
    };
    dispatch({
      type: types.UserTypes.USER_GET_ERRORS,
      payload: errorData
    });
  }
};

// on delete face from aws
const deleteFace = (userLocationId, userId, loginType) => async (
  dispatch
) => {
  try {
    const { baseUrlPython } = await helperFunction.checkLoginType(
      loginType
    );
    const deleteFaceSuccess = await axios.post(
      `${baseUrlPython}${api.Users_Api.DELETE_FACE_API}/${userId}/${userLocationId}`
    );
    dispatch({
      type: types.UserTypes.DELETE_FACE,
      payload: deleteFaceSuccess.data
    });
  } catch (deleteFaceError) {
    const errorData = {
      data: deleteFaceError.response.data,
      status: deleteFaceError.response.status
    };
    dispatch({
      type: types.UserTypes.USER_GET_ERRORS,
      payload: errorData
    });
  }
};

// on onGeoFencing
const onGeoActiveRestrict = (
  userArray,
  type,
  loginType,
  allUsers,
  typeValue
) => async (dispatch) => {
  try {
    const { baseUrlNode } = await helperFunction.checkLoginType(
      loginType
    );
    const geoActiveRestSuccess = await axios.post(
      `${baseUrlNode}${api.Users_Api.USER_GEO_REST_ACTIVE_API}/${type}/${typeValue}`,
      userArray
    );
    dispatch({
      type: types.UserTypes.GEO_ACTIVE_RESTRICT,
      payload: {
        message: geoActiveRestSuccess.data.message,
        allUsers,
        typeValue,
        type
      }
    });
  } catch (geoActiveRestError) {
    const errorData = {
      data: geoActiveRestError.response.data,
      status: geoActiveRestError.response.status
    };
    dispatch({
      type: types.UserTypes.USER_GET_ERRORS,
      payload: errorData
    });
  }
};

// on assigning rule to user
const onAssigningRuleToUser = (
  userArray,
  loginType,
  allUsers,
  ruleLocationName,
  ruleShiftType,
  ruleCode
) => async (dispatch) => {
  try {
    const { baseUrlNode } = await helperFunction.checkLoginType(
      loginType
    );
    const onRuleAssignSuccess = await axios.post(
      `${baseUrlNode}${api.Users_Api.ASSIGN_RULE_TO_USER_API}`,
      userArray
    );
    dispatch({
      type: types.UserTypes.ASSIGN_RULE_TO_USER,
      payload: {
        message: onRuleAssignSuccess.data.message,
        allUsers,
        ruleLocationName,
        ruleShiftType,
        ruleCode
      }
    });
  } catch (nRuleAssignError) {
    const errorData = {
      data: nRuleAssignError.response.data,
      status: nRuleAssignError.response.status
    };
    dispatch({
      type: types.UserTypes.USER_GET_ERRORS,
      payload: errorData
    });
  }
};

// on onDeleteUser
const onDeleteUser = (
  userArray,
  userType,
  loginType,
  allUsers,
  isActive
) => async (dispatch) => {
  try {
    const { baseUrlNode } = await helperFunction.checkLoginType(
      loginType
    );
    const deleteUserSuccess = await axios.post(
      `${baseUrlNode}${api.Users_Api.DELETE_USER_API}/${userType}`,
      userArray
    );
    dispatch({
      type: types.UserTypes.DELETE_USER,
      payload: {
        message: deleteUserSuccess.data.message,
        allUsers,
        isActive
      }
    });
  } catch (deleteUserError) {
    const errorData = {
      data: deleteUserError.response.data,
      status: deleteUserError.response.status
    };
    dispatch({
      type: types.UserTypes.USER_GET_ERRORS,
      payload: errorData
    });
  }
};

// change password
const changePassword = (userInfo, loginType) => async (dispatch) => {
  try {
    const { baseUrlNode } = await helperFunction.checkLoginType(
      loginType
    );
    const changePasswordSuccess = await axios.post(
      `${baseUrlNode}${api.Users_Api.CHANGE_PASSWORD_API}`,
      userInfo
    );

    dispatch({
      type: types.UserTypes.CHANGE_PASSWORD,
      payload: changePasswordSuccess.data
    });
  } catch (changePasswordError) {
    const errorData = {
      data: changePasswordError.response.data,
      status: changePasswordError.response.status
    };
    dispatch({
      type: types.UserTypes.USER_GET_ERRORS,
      payload: errorData
    });
  }
};

// edit user
const onEditUserDetail = (userInfo, userId, loginType) => async (
  dispatch
) => {
  try {
    const { baseUrlNode } = await helperFunction.checkLoginType(
      loginType
    );
    const editUserSuccess = await axios.post(
      `${baseUrlNode}${api.Users_Api.GET_USER_DETAIL_API}/${userId}`,
      userInfo
    );
    dispatch({
      type: types.UserTypes.EDIT_USER,
      payload: editUserSuccess.data
    });
  } catch (editUserError) {
    const errorData = {
      data: editUserError.response.data,
      status: editUserError.response.status
    };
    dispatch({
      type: types.UserTypes.USER_GET_ERRORS,
      payload: errorData
    });
  }
};

// clear shift loading
const setShiftLoading = (data) => (dispatch) => {
  dispatch({
    type: types.UserTypes.SHIFT_SET_LOADING,
    payload: data
  });
};

// clear shift result
const clearShiftResult = () => (dispatch) => {
  dispatch({
    type: types.UserTypes.SHIFT_CLEAR_RESULT
  });
};

// clear shift error
const clearShiftErrors = () => (dispatch) => {
  dispatch({
    type: types.UserTypes.SHIFT_CLEAR_ERROR
  });
};

// shift change
const shiftChange = (shiftData, loginType) => async (dispatch) => {
  try {
    const { baseUrlPython } = await helperFunction.checkLoginType(
      loginType
    );
    const shiftChangeSuccess = await axios.post(
      `${baseUrlPython}${api.Users_Api.SHIFT_CHANGE_API}/${loginType}`,
      shiftData
    );
    dispatch({
      type: types.UserTypes.SHIFT_CHANGE,
      payload: shiftChangeSuccess.data
    });
  } catch (shiftChangeError) {
    const errorData = {
      data: shiftChangeError.response.data,
      status: shiftChangeError.response.status
    };
    dispatch({
      type: types.UserTypes.SHIFT_GET_ERRORS,
      payload: errorData
    });
  }
};

export {
  getDevices,
  deleteDevices,
  addDevices,
  addPhoto,
  deleteFace,
  getAllUsers,
  shiftChange,
  onDeleteUser,
  getUserDetail,
  resetPassword,
  changePassword,
  setUserLoading,
  clearUserErrors,
  clearUserResult,
  setShiftLoading,
  getAllUserImages,
  clearShiftResult,
  onEditUserDetail,
  clearShiftErrors,
  getAllFilterUsers,
  // getAllAwsUsers,
  onGeoActiveRestrict,
  unmountAllUsersData,
  getUserCalendarData,
  onAssigningRuleToUser,
  addLocationToUserAction,
  setAddLocationLoading,
  setAddDeviceLoading
};
